
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/[slug]",
      function () {
        return require("private-next-pages/africa/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/[slug]"])
      });
    }
  